import { PageLayout } from "../components/PageLayout";
import { Card, CardContent, CardHeader } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { createCheckoutSession } from "../lib/api";

const plans = [
  {
    id: "free",
    title: "Free",
    price: 0,
    description: "Basic features with limited AI conversions",
  },
  {
    id: "pro",
    title: "Pro",
    price: 10,
    description: "Unlimited conversions and priority support",
    priceId: "price_1RQBsiHdQhjSWEZI4OyN8lqt",
  },
  {
    id: "enterprise",
    title: "Enterprise",
    price: 30,
    description: "Team management and advanced collaboration",
    priceId: "price_1RQByUHdQhjSWEZIBe914L4q",
  },
];

export default function PricingPage() {
  const handleCheckout = async (priceId: string) => {
    const url = await createCheckoutSession(priceId);
    if (url) {
      window.location.href = url;
    }
  };

  return (
    <PageLayout>
      <div className="container py-12 grid gap-8 md:grid-cols-3">
        {plans.map((plan) => (
          <Card key={plan.id} className="text-center space-y-4">
            <CardHeader className="text-xl font-bold">{plan.title}</CardHeader>
            <CardContent className="space-y-4">
              <p>{plan.description}</p>
              <p className="text-4xl font-bold">
                {plan.price === 0 ? "Free" : `$${plan.price}/mo`}
              </p>
              {plan.price > 0 && (
                <Button onClick={() => handleCheckout(plan.priceId!)}>
                  Upgrade
                </Button>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </PageLayout>
  );
}
